import { getBookingTag, getCourtsText, getPlayerFirstNameAndLastInitial } from '../../util/bookingUtil'

import { Typography } from 'antd'
import _ from 'lodash'
import { formatDateTime } from '../../util/dateTimeUtil'

const { Text } = Typography

const format = (time) => {
  if (_.isNil(time)) {
    return ''
  }
  return formatDateTime(time, 'h:mmaaa')
}

const BookingDisplay = ({ title, booking, hide, onClick }) => {
  const handleClick = () => {
    hide?.()
    onClick?.(booking)
  }

  if (!booking) {
    return 'None'
  }

  const tag = getBookingTag(booking)

  const players = ''
  return (
    <div className="bookingUpcoming">
      <div
        className="upcomingBookingLink"
        onClick={handleClick}
        title={
          booking.isOwnBooking
            ? 'Booked by me'
            : `Booked by ${getPlayerFirstNameAndLastInitial(booking.createdByUser, true)}`
        }
      >
        <Text className="date">{formatDateTime(booking.startTime, 'EEE MMM d')}</Text>
        <Text className="bookingUpcoming" style={{ fontSize: '.8em' }}>
          {' '}
          @{' '}
        </Text>
        <Text className="time">{format(booking.startTime)}</Text>
        <Text className="court">{getCourtsText(booking)}</Text>
        {tag}
        {!_.isEmpty(players) && (
          <>
            <Text className="players">{players}</Text>{' '}
          </>
        )}
      </div>
    </div>
  )
}

export default BookingDisplay
